import { sleep } from './utils';
import { lru } from 'tiny-lru';

const PAGE_READY_DELAY = 2000;

export const positionTutorialTip = async(tipEl) =>
{
	if(tipEl?.current) tipEl = tipEl.current;
	if(!tipEl) return;

	const doPosition = () =>
	{
		console.log(tipEl);
		tipEl.classList.add('showtip');
		const rect = tipEl.getBoundingClientRect();
		const screenWidth = window.innerWidth;
		console.log(rect);

		let textShift = 0;
		if (rect.left < 0)
		{ // Check if left edge is off screen
			textShift = Math.abs(rect.left) + 10;
		}
		if (rect.right > screenWidth)
		{ // Check if right edge is off screen
			textShift = screenWidth - (Math.abs(rect.right)+10);
		}

		const arrowShift = Math.max(10, Math.min(rect.width-10, 60-textShift));
		tipEl.style.setProperty('--tiptext-shift', `${textShift}px`);
		tipEl.style.setProperty('--tiparrow-shift', `${arrowShift}px`);

	}

	const [nav] = performance.getEntriesByType("navigation");
	if(performance.now()-nav.loadEventEnd > PAGE_READY_DELAY)
	{
		doPosition();
	} else
	{
		await sleep(PAGE_READY_DELAY);
		doPosition();
	}
	while(tipEl.getBoundingClientRect().left<0 || tipEl.getBoundingClientRect().right>window.innerWidth)
	{
		doPosition();
		await sleep(100);
	}
}

const cache = lru(500, 1000);
export const positionAllTutorialTips = () =>
	[...document.querySelectorAll('.tiptext.showtip')].forEach(e => 
	{
		if(cache.get(e.innerText)) return;
		positionTutorialTip(e);
		cache.set(e.innerText, 1);
	} );
